<template>
    <section class="model-comparison">
        <loading-element :z-index="2" class="continue-button__spinner" :is-loading="isLoading" :bg-color="'rgb(255, 255, 255)'" center absolute ></loading-element>
        <slot name="empty" v-if="products.length === 0"></slot>

        <ComparisonItem v-for="(item, index) of this.products" :key="index" :data="item.data.product"
                        @delete-item="deleteItem(item.data.product.shopProductId)">
            <template v-slot:button-label>
                <a :href="addUmbrellaToDealerUrl(item.data.product.sku)" class="btn-primary">{{t('compare.buttonaction')}}</a>
            </template>
        </ComparisonItem>
    </section>
</template>

<script>
    import ComparisonItem from "./ComparisonItem.vue";
    import { eventBus } from "fire-vue-core";
    import { LoadingElement } from 'fire-vue-core';
    import {FireI18n} from 'fire-js-i18n';
    import InlineSvg from 'vue-inline-svg';

    export default {
        name: 'ModelComparison',
        provide() {
            // use function syntax so that we can access `this`
            return {
              tooltips: this.tooltips
            }
          },
        components: {
            LoadingElement,
            ComparisonItem,
            'inline-svg': InlineSvg
        },
        data: () => ({
            getSelectedProducts: [],
            products: [],
            isLoading: true,
        }),
        props: {
            dealerUrl: '',
            tooltips: {}
        },
        methods: {
            fetchData() {
                return fetch(apiBaseUrl + "compare/get?ids=" + this.getSelectedProducts.join('_'))
                    .then((response) => response.json())
                    .then(data => {
                        this.products = data;
                        this.isLoading = false;
                    })
                    .catch(err => console.log(err));
            },
            addUmbrellaToDealerUrl(sku){
                sku = sku.replace('_', '='); //pre sku umbrella_180
                return this.dealerUrl + '?' + sku;
            },
            t(key, options) {
                return FireI18n.t(key, options);
            },
        },
        mounted() {
            if (localStorage.comparisonProducts) {
                this.getSelectedProducts = JSON.parse(localStorage.comparisonProducts);
                this.fetchData();
            } else {
                //no compare products stop loading
                this.isLoading = false;
            }

            eventBus.$on('updateDataCompareAll', (id) => {
                this.getSelectedProducts = JSON.parse(localStorage.comparisonProducts);
                this.fetchData();
            });
        }
    }
</script>

<style lang="scss">
    .model-comparison {
        display: flex;
        gap: 20px;
        min-width: 160px;
        max-width: 100%;
        overflow-x: auto;

        .specs-sidebar {
            background: transparent;
            min-width: 180px;

            @media ( min-width: 1024px ) {
                display: none;
            }

            .item-header,
            hr {
                visibility: hidden;
            }

            .deleteItem {
                display: none;
            }

            .item-specs {
                @media ( max-width: 1024px ) {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                }

                h3 {
                    opacity: 1;
                    margin: 0 !important;
                }

                ul {
                    li {
                        .label {
                            display: block;
                        }

                        .value {
                            display: none;
                        }
                    }
                }
            }

            .item-footer {
                visibility: hidden;
            }
        }

        .label-container {
          .text {
            padding: 0.9em;
            display: block;
            color: white;
            font-weight: 400;
            font-size: 0.8125rem;
            text-align: center;
            line-height: 1.2em;
            .label {
              svg {
                margin-left: 5px;
              }
            }
          }
          .icon {
            position: relative;
          }
        }
        .tooltip-compare {
            position: absolute;
            left: -92px;
            top: calc(100% + 12px);
            background-color: #6C6C6C;
            transition: opacity .3s;
            visibility: hidden;
            opacity: 0;
            width: 200px;
            z-index: -1;
            &:after {
                display: block;
                content: '';
                position: absolute;
                width: 14px;
                height: 14px;
                left: 50%;
                top: -6px;
                background-color: #6C6C6C;
                transform: translateX(-50%) rotate(45deg);
            }
        }
        .label-container:hover .tooltip-compare {
            z-index: 2;
            visibility: visible;
            opacity: 1;
        }
    }
</style>